import * as yup from "yup";

const deleteSchema = (translate: Function) => yup.object().shape({
	efa027Dominio: yup.string().required(translate("Nome do grupo não confere")).oneOf([yup.ref("efa027DominioConfirmation")], translate("Nome do grupo não confere"))
});

const addAndChangeSchema = (translate: Function) => yup.object().shape({
	efa027Dominio: yup.string().required(translate("Domínio é requerido"))
});


export { deleteSchema, addAndChangeSchema };
